import React from 'react';
import { useTranslation } from 'react-i18next';

function Alert(props: { isSuccessed: boolean; email: string; setQuestionDialog: Function; setAlert: Function }) {
    const { t } = useTranslation();
    return (
        <div style={{ position: 'fixed', top: '0px', left: '0px', bottom: '0px', right: '0px', zIndex: 1000 }}>
            <div
                style={{
                    overflow: 'hidden',
                    position: 'fixed',
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '0px',
                    zIndex: 1100,
                    background: 'rgb(0, 0, 0)',
                    opacity: 0.3,
                }}
            ></div>
            <div style={{ display: 'table', width: '100%', height: '100%', verticalAlign: 'middle' }}>
                <div style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>
                    <div
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                            zIndex: 1200,
                            minWidth: '280px',
                            padding: '20px 30px',
                            background: 'rgb(255, 255, 255)',
                            border: '1px solid rgb(231, 231, 231)',
                        }}
                    >
                        <div style={{ textAlign: 'center' }}>
                            {props.isSuccessed ? (
                                <svg
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    style={{
                                        display: 'inline-block',
                                        fill: 'rgb(31, 196, 124)',
                                        height: '38px',
                                        width: '38px',
                                        userSelect: 'none',
                                        marginBottom: '9px',
                                    }}
                                >
                                    <path d="M11.99-0.013c-6.632,0-12.004,5.383-12.004,12.016c0,6.633,5.372,12.015,12.002,12.015 c6.644,0,12.026-5.383,12.026-12.015C24.016,5.37,18.633-0.013,11.99-0.013z M11.995,22.083c-5.583,0-10.106-4.521-10.106-10.105 c0-5.583,4.523-10.106,10.106-10.106s10.106,4.521,10.106,10.106C22.102,17.562,17.578,22.083,11.995,22.083z M10.375,15.036 L6.55,11.222l-1.504,1.501l5.33,5.33l8.526-8.526L17.4,8.013L10.375,15.036z"></path>
                                </svg>
                            ) : (
                                <svg
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    style={{
                                        display: 'inline-block',
                                        fill: 'rgb(252, 83, 86)',
                                        height: '38px',
                                        width: '38px',
                                        userSelect: 'none',
                                        marginBottom: '9px',
                                    }}
                                >
                                    <path d="M11.991-0.003c-6.626,0-11.994,5.378-11.994,12.005c0,6.627,5.368,12.004,11.994,12.004 c6.638,0,12.015-5.377,12.015-12.004C24.006,5.375,18.629-0.003,11.991-0.003z M11.996,22.072 c-5.579,0-10.098-4.518-10.098-10.097c0-5.579,4.519-10.096,10.098-10.096s10.097,4.518,10.097,10.096 C22.093,17.555,17.574,22.072,11.996,22.072z M10.749,14.521h2.525V5.685l-2.52,0.013L10.749,14.521z M10.749,18.309h2.525 v-2.523h-2.525V18.309z"></path>
                                </svg>
                            )}

                            <h1
                                style={{
                                    margin: '0px',
                                    padding: '0px 0px 10px',
                                    fontSize: '22px',
                                    fontFamily: 'Nanum Square, 돋움, Dotum, Helvetica, Apple SD Gothic Neo sans-serif',
                                    lineHeight: '26px',
                                }}
                            >
                                {props.isSuccessed
                                    ? t("enquiryRegistrationAlert")
                                    : t("checkInfo1")}
                            </h1>
                            <div
                                style={{
                                    paddingBottom: '10px',
                                    fontSize: '16px',
                                    fontFamily:
                                        "'Nanum Square', 돋움, Dotum, Helvetica, 'Apple SD Gothic Neo', sans-serif",
                                    lineHeight: '20px',
                                }}
                            >
                                {
                                    props.isSuccessed
                                        ? `${props.email} ${t("replyEmail")}`
                                        : t("validationError")
                                }
                            </div>

                            <div
                                style={{
                                    paddingBottom: '10px',
                                    fontSize: '16px',
                                    fontFamily:
                                        "'Nanum Square', 돋움, Dotum, Helvetica, 'Apple SD Gothic Neo', sans-serif",
                                    lineHeight: '20px',
                                }}
                            >
                                {
                                    props.isSuccessed
                                        ? ''
                                        : t("checkInfo2")
                                }
                            </div>


                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <button
                                type="button"
                                tabIndex={0}
                                style={{
                                    boxSizing: 'border-box',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    outline: 'none',
                                    position: 'relative',
                                    textAlign: 'center',
                                    verticalAlign: 'top',
                                    borderRadius: '0px',
                                    border: '1px solid rgb(28, 144, 251)',
                                    background: 'rgb(28, 144, 251)',
                                    color: 'rgb(255, 255, 255)',
                                    textDecoration: 'none',
                                    fontSize: '12px',
                                    fontFamily:
                                        '"Nanum Square", 돋움, Dotum, Helvetica, "Apple SD Gothic Neo", sans-serif',
                                    height: '30px',
                                    lineHeight: 'initial',
                                    padding: '1px 0px 0px',
                                    width: '65px',
                                    marginRight: '5px',
                                }}
                                onClick={() =>
                                    props.isSuccessed ? props.setQuestionDialog(false) : props.setAlert({ open: false })
                                }
                            >
                                <span>{t("ok")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Alert;
